var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.internalBreadcrumb.length > 0)?_c('div',{staticClass:"p-the-header-breadcrumb"},[_c('ol',{staticClass:"p-the-header-breadcrumb__list"},_vm._l((_vm.internalBreadcrumb),function(ref,key){
var url = ref.url;
var text = ref.text;
var pageType = ref.pageType;
return _c('li',{key:key,staticClass:"p-the-header-breadcrumb__list__item"},[_c('BreadcrumbLink',{attrs:{"url":url,"last-element":key === _vm.lastElementKey,"text":text,"page-type":pageType,"item-key":key}})],1)}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }